import React, { useState, useEffect } from "react";
import "./Clients.css";

export default function Clients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [displayCount, setDisplayCount] = useState(6);

  useEffect(() => {
    fetchClients();
    fetchDisplayCount();
  }, []);

  const fetchClients = async () => {
    try {
      const response = await fetch("/api/clients?sort=rank");
      const data = await response.json();
      setClients(data.filter((c) => c.visibility === "public"));
      setLoading(false);
    } catch (err) {
      console.error("Error fetching clients:", err);
      setLoading(false);
    }
  };

  const fetchDisplayCount = async () => {
    try {
      const response = await fetch("/api/settings/clients-display-count");
      const data = await response.json();
      if (data.value) setDisplayCount(data.value);
    } catch (err) {
      console.error("Error fetching display count:", err);
    }
  };

  if (loading) {
    return (
      <section className="section shell">
        <p>Loading clients...</p>
      </section>
    );
  }

  if (clients.length === 0) {
    return null;
  }

  return (
    <section
      className="section shell"
      style={{ paddingTop: "60px", paddingBottom: "120px" }}
    >
      <div style={{ marginBottom: "48px" }}>
        <div className="section-label reveal">01 — Trusted by</div>
        <h2
          className="display clients__title reveal"
          style={{ marginTop: "32px", fontSize: "clamp(32px, 5vw, 60px)" }}
        >
          Trusted partners and clients across{" "}
          <em style={{ color: "rgba(244, 241, 234, 0.4)" }}>verticals.</em>
        </h2>
      </div>
      <div className="logos">
        {clients.slice(0, displayCount).map((client) => (
          <div key={client._id} className="logo reveal">
            {client.logo ? (
              <img src={client.logo} alt={client.name} className="logo-image" />
            ) : (
              <span title={client.industry}>{client.name}</span>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
